import { render, staticRenderFns } from "./receipt-egress-component.vue?vue&type=template&id=21bfedbb&scoped=true&"
import script from "./receipt-egress-component.vue?vue&type=script&lang=js&"
export * from "./receipt-egress-component.vue?vue&type=script&lang=js&"
import style0 from "./receipt-egress-component.vue?vue&type=style&index=0&id=21bfedbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bfedbb",
  null
  
)

export default component.exports